<template>
  <ul
    ref="list"
    class="sm-messages__main-messages-list scrollable-y"
    @scroll="onScroll"
  >
    <ul  
      class="sm-messages__main-messages-list-sub"
      v-for="group in listWithDays"
      :key="group.date"
    >
      <message-item
        v-for="message in group.messages"
        :message="message"
        :selectedMessage="selectedMessage"
        :key="message.id"
        :isMobile="isMobile"
      />
      <li class="sm-messages__main-messages-list-seperator">
        <div class="horizontal-line"></div>
        <div class="date">
          <span class="sm-text-muted">{{ formatDate(group.date) }}</span>
        </div>
      </li>
    </ul>
    <li
      v-if="listWithDays.length === 0"
      class="sm-messages__main-messages-list-empty"
    >
      This is the very beginning of messaging with
      {{ role === 'admin' ? getFullName(selectedRoom.customer) : 'your operator' }}.
    </li>
    <li
      v-if="endOfMessages"
      class="sm-txt-center sm-text-muted"
    >
      No more Messages
    </li>
  </ul>
</template>

<script>

import MessageItem from "./MessageItem.vue"

export default {
  name: "messages-list",
  components: {
    "message-item" : MessageItem,
  },
  props: {
    messagesObj: {
      type: Object,
      required: true,
    },
    userAccount: {
      type: Object,
      required: true,
    },
    selectedRoom: {
      type: Object,
      required: true,
    },
    selectedMessage: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    role: {
      type: String,
      default: 'admin',
    },
    endOfMessages: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    listWithDays() {
      if (this.messagesObj.hasOwnProperty("messages")) {
        const groups = this.messagesObj.messages.reduce((groups, message) => {
          const date = this.$moment(message.created_at).format("DD/MM/YY");
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(message);
          return groups;
        }, {});

        const groupArrays = Object.keys(groups).map((date) => {
          return {
            date,
            messages: groups[date],
          };
        });

        return groupArrays;
      } else {
        return [];
      }
    },
  },
  methods: {
    
    getFullName(person) {
      if (person.full_name) return person.full_name;
      else return person.first_name + " " + person.last_name;
    },
    scrollToTheBottom() {
      this.$refs.list.scrollTop = 0;
    },
    formatDate(date) {
      const d = this.$moment(date, "DD/MM/YY");
      const sameElseFormat =
        this.$moment().year() === d.year() ? "DD MMMM" : "DD MMMM YYYY";
      return d.calendar(null, {
        sameDay: "[Today]",
        lastDay: "[Yesterday]",
        lastWeek: "dddd",
        sameElse: sameElseFormat,
      });
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (this.messagesObj.total_pages > this.messagesObj.page) {
        if (-scrollTop + clientHeight >= scrollHeight) {
          this.$emit("loadMore", this.selectedRoom.id);
        }
      }
    },
  },
  watch: {
    messagesObj(newValue, oldValue) {
      if (
        newValue.messages && oldValue.messages &&
        newValue.messages[0] && oldValue.messages[0] &&
        oldValue.messages[0].id !== newValue.messages[0].id
      )
        this.scrollToTheBottom();
    },
  },
};
</script>
